import axios from "axios";

function getHeaders() {
  return {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
}

function getHeaders2() {
  return {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
}

export const getDomain = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/post_services/domain/get-all-domain/`,
      getHeaders()
    );

    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Backend Error:", error.response.data);
    } else {
      console.error("Network Error:", error);
    }
    throw error;
  }
};

export const getDomainById = async (Id) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/post_services/domain/${Id}/get-domain-by-id/`,
      getHeaders()
    );

    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Backend Error:", error.response.data);
    } else {
      console.error("Network Error:", error);
    }
    throw error;
  }
};

export const createDomain = async (domainName) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/post_services/domain/create-new-domain/`,
      { domain_name: domainName },
      getHeaders()
    );

    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Backend Error:", error.response.data);
    } else {
      console.error("Network Error:", error);
    }
    throw error;
  }
};
export const updateDomain = async (id, data) => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_BASE_URL}/post_services/domain/${id}/update-domain/`,
      data,
      getHeaders()
    );
    return response.data;
  } catch (error) {
    console.error("Error updating domain:", error);
    throw error;
  }
};
export const deleteDomain = async (id) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/post_services/domain/${id}/delete-domain/`,
      getHeaders()
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting domain:", error);
    throw error;
  }
};

export const uploadDocuments = async (id, data) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/post_services/domain/${id}/add_value_uni_link/`,
      data,
      getHeaders2()
    );

    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Backend Error:", error.response.data);
    } else {
      console.error("Network Error:", error);
    }
    throw error;
  }
};

export const addDynamicField = async (id, dynamicFields) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/post_services/domain/${id}/add-dynamic-field/`,
      { dynamic_fields: dynamicFields },
      getHeaders()
    );

    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Backend Error:", error.response.data);
    } else {
      console.error("Network Error:", error);
    }
    throw error;
  }
};
export const putFinalizedData = async (studentId, data) => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_BASE_URL}/student/${studentId}/is-finalized-excel/`,
      { student_id: studentId, is_finalized_excel: data },
      getHeaders()
    );

    return response.data;
  } catch (error) {
    console.error("Error adding shortlisting entry:", error);
    throw error;
  }
};
export const removeDynamicField = async (id, fieldKey) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/post_services/domain/${id}/add-dynamic-field/`,
      {
        field_key: fieldKey,
      },
      getHeaders()
    );
    return response.data;
  } catch (error) {
    console.error("Error removing dynamic field:", error);
    throw error;
  }
};

export const createPostServiceStudent = async (studentData) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/post_services/students/`,
      studentData,
      getHeaders()
    );

    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Backend Error:", error.response.data);
    } else {
      console.error("Network Error:", error);
    }
    throw error;
  }
};

export const updatePostServiceStudent = async (studentData) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/post_services/students/id/${studentData.user_id}/`,
      studentData,
      getHeaders()
    );

    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Backend Error:", error.response.data);
    } else {
      console.error("Network Error:", error);
    }
    throw error;
  }
};

export const getAllPostStudents = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/post_services/students/`,
      getHeaders()
    );

    return response.data.data;
  } catch (error) {
    if (error.response) {
      console.error("Backend Error:", error.response.data);
    } else {
      console.error("Network Error:", error);
    }
    throw error;
  }
};

export const deleteCareerCounselingStudent = async (id) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/post_services/students/id/${id}/`,
      getHeaders()
    );

    return response.data.data;
  } catch (error) {
    if (error.response) {
      console.error("Backend Error:", error.response.data);
    } else {
      console.error("Network Error:", error);
    }
    throw error;
  }
};
export const deleteDocument = async (id, field_key, file_path) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/post_services/domain/${id}/remove_value_uni_link/?field_key=${field_key}&file_path=${file_path}`,
      getHeaders()
    );

    return response.data.data;
  } catch (error) {
    if (error.response) {
      console.error("Backend Error:", error.response.data);
    } else {
      console.error("Network Error:", error);
    }
    throw error;
  }
};

export const getStudentWithUUID = async (id) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/post_services/students/uuid/${id}/`
      // getHeaders()
    );
    return response.data.data;
  } catch (error) {
    if (error.response) {
      console.error("Backend Error:", error.response.data);
    } else {
      console.error("Network Error:", error);
    }
    throw error;
  }
};
